<ng-container *ngIf="!isGridsterInMobileMode" [ngTemplateOutlet]="standardView"></ng-container>
<ng-container *ngIf="isGridsterInMobileMode" [ngTemplateOutlet]="miniModeView"></ng-container>

<ng-template #miniModeView>
    <toro-dashboard-widget-container
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            [isMiniModeWidget]="true"
            (gotoSite)="onLinkClick()"
    >
        <div class="toro-flex-child mini-mode-widget-container toro-component-shield-host">
            <div id="tp-mm-gauges" class="prevent-select">
                <ng-container [ngTemplateOutlet]="circularGauges"></ng-container>
            </div>

            <toro-component-shield (shieldClick)="showMiniModeModal = !showDesktopModal"></toro-component-shield>
        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #standardView>
    <toro-dashboard-widget-container
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            (gotoSite)="onLinkClick()"
    >
        <div class="toro-flex-child">

            <div *ngIf="displayCols == 1 && displayRows == 1" class="toro-widget-content-pane c1-r1" [ngClass]="{'fade-on-resize': isResizing && !isBusy, 'is-demo': isDemoMode}">
                <ng-container [ngTemplateOutlet]="sortFilter"></ng-container>

                <ng-container [ngTemplateOutlet]="actionButton"></ng-container>

                <ng-container [ngTemplateOutlet]="assetsContainer"></ng-container>
            </div>

            <div *ngIf="displayCols == 1 && displayRows == 2" class="toro-widget-content-pane c1-r2" [ngClass]="{'fade-on-resize': isResizing && !isBusy}">
                <toro-turf-pro-linear-gauge
                        [totalCount]="turfProAssets?.length"
                        [offCount]="statusOffCount"
                        [waitingCount]="statusWaitingCount"
                        [activeCount]="statusActiveCount"
                ></toro-turf-pro-linear-gauge>

                <ng-container [ngTemplateOutlet]="sortFilter"></ng-container>

                <ng-container [ngTemplateOutlet]="assetsContainer"></ng-container>

                <ng-container [ngTemplateOutlet]="actionButton"></ng-container>
            </div>

        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #titleIcon>
    <img id="tp-title-icon" src="../../../../../../assets/images/turf-pro/turf-pro-logo.svg" alt="">
</ng-template>

<ng-template #sortFilter>
    <div id="my-header-container">
        <p-dropdown [disabled]="sortSelectList?.length < 2"
                    [options]="sortSelectList"
                    [(ngModel)]="selectedSortKey"
                    styleClass="tid-my-dropdown"
                    dropdownIcon="pi pi-sort-amount-down"
        ></p-dropdown>
        <p-dropdown [disabled]="filterSelectList?.length < 2"
                    [options]="filterSelectList"
                    [(ngModel)]="selectedFilterKey"
                    styleClass="tid-my-dropdown"
                    dropdownIcon="pi pi-filter"
        ></p-dropdown>
    </div>
</ng-template>

<ng-template #actionButton>
    <div id="tp-action-button" (click)="onShowDesktopModal()">
        <span class="prevent-select">{{ 'CASE_SENSITIVE.VIEW_ALL_MACHINES' | translate }}</span>
    </div>
</ng-template>

<ng-template #assetsContainer>
    <div id="tp-assets-container">
        <div id="tp-assets-scroll-container">
            <toro-turf-pro-asset-card
                    *ngFor="let asset of filteredAndSortedAssets"
                    [asset]="asset"
            ></toro-turf-pro-asset-card>
        </div>
    </div>
</ng-template>

<ng-template #circularGauges>
    <toro-turf-pro-gauge
            [maxHeightPx]="showDesktopModal ? maxModalGaugeHeightPx : undefined"
            [label]="'STRINGS.OFF' | translate"
            [labelVerticalOffsetPx]="!showDesktopModal ? gaugeLblVertOffsetMini : gaugeLblVertOffsetModal"
            [value]="statusOffCount"
            [minValue]="0"
            [maxValue]="turfProAssets?.length"

    ></toro-turf-pro-gauge>
    <toro-turf-pro-gauge
            [valueColor]="'#9DC1DB'"
            [trackColor]="'#E9F8FF'"
            [maxHeightPx]="showDesktopModal ? maxModalGaugeHeightPx : undefined"
            [label]="'STRINGS.WAITING' | translate"
            [labelVerticalOffsetPx]="!showDesktopModal ? gaugeLblVertOffsetMini : gaugeLblVertOffsetModal"
            [value]="statusWaitingCount"
            [minValue]="0"
            [maxValue]="turfProAssets?.length"
    ></toro-turf-pro-gauge>
    <toro-turf-pro-gauge
            [valueColor]="'#00A67F'"
            [trackColor]="'#EAFCEE'"
            [maxHeightPx]="showDesktopModal ? maxModalGaugeHeightPx : undefined"
            [label]="'STRINGS.ACTIVE' | translate"
            [labelVerticalOffsetPx]="!showDesktopModal ? gaugeLblVertOffsetMini : gaugeLblVertOffsetModal"
            [value]="statusActiveCount"
            [minValue]="0"
            [maxValue]="turfProAssets?.length"
    ></toro-turf-pro-gauge>
    <toro-turf-pro-gauge
            [valueColor]="'#747474'"
            [trackColor]="'#3F3F3F1A'"
            [maxHeightPx]="showDesktopModal ? maxModalGaugeHeightPx : undefined"
            [label]="'STRINGS.TOTAL' | translate"
            [labelVerticalOffsetPx]="!showDesktopModal ? gaugeLblVertOffsetMini : gaugeLblVertOffsetModal"
            [value]="turfProAssets?.length"
            [minValue]="0"
            [maxValue]="turfProAssets?.length"
    ></toro-turf-pro-gauge>
</ng-template>

<toro-mini-mode-widget-modal *ngIf="showMiniModeModal" (cancel)="showMiniModeModal = false">
    <div id="mini-mode-modal-content-container">
        <div id="tp-mm-gauges" class="prevent-select">
            <ng-container [ngTemplateOutlet]="circularGauges"></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="sortFilter"></ng-container>

        <ng-container [ngTemplateOutlet]="assetsContainer"></ng-container>
    </div>
</toro-mini-mode-widget-modal>

<toro-turf-pro-asset-modal
        *ngIf="showDesktopModal"
        [isMiniModal]="isGridsterInMobileMode"
        (gotoSite)="onLinkClick()"
        (cancel)="showDesktopModal = false;"
>
    <div id="tp-modal-content">
        <div id="tpm-gauges">
            <ng-container [ngTemplateOutlet]="circularGauges"></ng-container>
        </div>

        <div id="tpm-assets" >
            <div id="tpm-toolbar">
                <div id="sort-filter-container">
                    <ng-container [ngTemplateOutlet]="sortFilter"></ng-container>
                </div>
                <div id="tpm-mower-count" class="prevent-select" *ngIf="filteredAndSortedAssets?.length > 0">
                    {{ filteredAndSortedAssets?.length }} {{ (filteredAndSortedAssets?.length == 1 ? 'STRINGS.MOWER' : 'STRINGS.MOWERS') | translate }}
                </div>
            </div>
            <div id="tpm-assets-list">
                <ng-container [ngTemplateOutlet]="assetsContainer"></ng-container>
            </div>
        </div>
    </div>
</toro-turf-pro-asset-modal>

<toro-turf-pro-api-token-dlg
    *ngIf="showTokenDlg"
    [apiKey]="newApiToken"
    (setApiKey)="onSetApiKey($event)"
    (cancelClick)="showTokenDlg = false"
></toro-turf-pro-api-token-dlg>


